import { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net";
import languageES from "datatables.net-plugins/i18n/es-MX";
import api from "@/api/api.js";

const fmt = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};

const esc = (s) =>
  String(s ?? "").replace(
    /[&<>"]/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c],
  );

const EmailLogViewer = () => {
  const tableRef = useRef(null);
  const dataTable = useRef(null);

  useEffect(() => {
    dataTable.current = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      language: languageES,
      order: [],
      ajax: async (dtParams, callback) => {
        try {
          const response = await api.get("/email_logs", {
            params: {
              page: dtParams.start / dtParams.length + 1,
              itemsPerPage: dtParams.length,
              search: dtParams.search?.value || undefined,
            },
          });
          callback({
            data: response.data["hydra:member"],
            recordsTotal: response.data["hydra:totalItems"],
            recordsFiltered: response.data["hydra:totalItems"],
          });
        } catch (error) {
          console.error("Error al cargar correos:", error);
          callback({ data: [] });
        }
      },
      columns: [
        {
          title: "Fecha",
          data: "createdAt",
          render: (data) => fmt(data),
        },
        {
          title: "Evento",
          render: (data, type, row) => esc(row.eventLabel || "—"),
        },
        { title: "Asunto", render: (data, type, row) => esc(row.subject) },
        {
          title: "Destinatarios",
          render: (data, type, row) => esc(row.recipients),
        },
        {
          title: "Estado",
          render: (data, type, row) =>
            row.status === "sent"
              ? '<span class="badge bg-success">Enviado</span>'
              : `<span class="badge bg-danger" title="${esc(row.error)}">Fallido</span>`,
        },
      ],
    });

    return () => {
      if (dataTable.current) {
        dataTable.current.destroy();
      }
    };
  }, []);

  return (
    <div className="col">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title pb-3">Correos enviados</h5>
          <p className="text-muted">
            Registro de todos los correos salientes (fecha, evento, asunto,
            destinatarios y estado). No se guarda el contenido del mensaje.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="display"
              style={{ width: "100%" }}
            ></table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailLogViewer;
